import "./certification.css";

import React from "react";

import { CERTIFICATION_PAGE } from "../../data/content";
import PageMeta from "../general/PageMeta";
import PageBanner from "../general/PageBanner";
import PhotoStrip from "../general/PhotoStrip";

const Certification = () => {
  return (
    <React.Fragment>
      <PageMeta title={CERTIFICATION_PAGE.metaTitle} />
      <PageBanner />

      <section className={"certification dark-page"}>
        <div className={"container"}>
          <h1 className={"page-title"}>{CERTIFICATION_PAGE.title}</h1>

          <ul className={"certificates"}>
            {CERTIFICATION_PAGE.documents.map((doc) => (
              <li key={doc.file}>
                <a
                  className={"certificate-preview"}
                  href={doc.file}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                  aria-label={`Open the ${doc.name} (PDF)`}
                >
                  <img
                    src={doc.image}
                    alt={""}
                    width={"276"}
                    height={"267"}
                  />
                </a>
                <p className={"certificate-name"}>{doc.name}</p>
                <a
                  className={"btn"}
                  href={doc.file}
                  download
                >
                  Download
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <PhotoStrip />
    </React.Fragment>
  );
};

export default Certification;
